import { ClueWord } from "./clueword.js";

export class ClueBoard {
  /**
   * @param {string[]} words - Array of word strings to display (letter sized).
   * @param {HTMLElement} domElement - The DOM element to render the clue board into.
   * @param {GridModelWord[]} [gridWords] - Array of GridModelWord objects for matching.
   */
  constructor(words, gridWords, domElement, controller) {
    this.words = Array.isArray(words) ? words : [];
    this.numLetters = this.words[0].length;
    this.headerLabelText = `${this.numLetters} Letters`;
    this.domElement = domElement;
    this.parentController = controller;

    // @fixme this can be made a lot faster knowing that the words and gridWords map one to one by index in
    // each of the corresponding arrays. In fact the word value of each word matches with the word
    // value of the grid word at the same index location.
    // this.clueWords = this.words.map(wordStr => {
    //     let gridWord = Array.isArray(gridWords)
    //         ? gridWords.find(gw => typeof gw.getWordValue === 'function' && gw.getWordValue() === wordStr)
    //         : null;
    //     return new ClueWord(wordStr, gridWord, this);
    // });

    // Create ClueWord instances, linking to GridModelWord if available
    if (Array.isArray(gridWords) && gridWords.length === this.words.length) {
      this.clueWords = this.words.map((wordStr, idx) => {
        return new ClueWord(wordStr, gridWords[idx], this);
      });
    }
  }

  /**
   * Renders the clue board into its existing DOM element.
   * The domElement should already be a clues-section div in the HTML.
   * This method populates it with the header and clue list.
   */
  render() {
    if (!this.domElement) return;
    if (this.words.length === 0) return;

    // Create an array of clue elements (li elements)
    const clueElements = this.clueWords.map((clueWord) =>
      clueWord.getClueElement()
    );

    // Clear the existing DOM element
    this.domElement.innerHTML = "";

    // Create and append the header element
    const headerElement = document.createElement("h3");
    headerElement.textContent = this.headerLabelText;
    this.domElement.appendChild(headerElement);

    // Create and append the unordered list element
    const cluesListUl = document.createElement("ul");
    cluesListUl.classList.add("clues-list");

    // Populate the unordered list with clues
    clueElements.forEach((clueLi) => {
      cluesListUl.appendChild(clueLi);
    });

    this.domElement.appendChild(cluesListUl);
  }

  /**
   * Returns the ClueWord instance matching the given word value.
   * @param {string} wordValue
   * @returns {ClueWord | undefined}
   */
  getClueWordByValue(wordValue) {
    return this.clueWords.find((clueWord) => clueWord.wordValue === wordValue);
  }

  /**
   * Counts the number of clue words that are marked as used.
   * Assumes ClueWord has an `isUsed` property or method.
   * @returns {number}
   */
  countUsedClueWords() {
    return this.clueWords.filter((clueWord) => clueWord.isUsed()).length;
  }

  /**
   * Called when a corresponding grid word has all of its tiles filled with guess characters.
   * @param {string} wordValue - The word value that was filled.
   */
  wordFilledSignal(wordValue) {
    console.log("SIGNAL:", wordValue);
    if (
      this.parentController &&
      typeof this.parentController.onClueWordFilled === "function"
    ) {
      this.parentController.onClueWordFilled(wordValue, this);
    }
  }
}
